import { addDoc, collection, doc, getDocs, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import React, { useContext, useEffect, useState } from 'react'
import { auth, db } from '../firebase'
import { googleAuth } from './GoogleAuthContext';

const AuthContext = React.createContext();

export function useAuth () {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [loading, setLoading] = useState(true);
    
    const [currentUser, setCurrentUser] = useState(() => {
        const user = auth.currentUser;
        return user;
      });

    function signup(email, password) {
        return auth.createUserWithEmailAndPassword(email, password);
    }

    function login(email, password, type) {
      if(type === undefined || type === "regular")
        return auth.signInWithEmailAndPassword(email, password);
      
      return googleAuth();
    }

    function logout(){
      const result = auth.signOut();
      return result;
    }

    function resetPassword(email) {
      auth.sendPasswordResetEmail(email);
    }

    
    
    const [userRole, setUserRole] = useState(''); 
    const [userName, setUserName] = useState('');
    const [userId, setUserId] = useState('');
    const [userImage, setUserImage] = useState('');
    const [userDocId, setUserDocId] = useState('');
    const [userImageFlag, setUserImageFlag] = useState(false);
  
    const getUser = async () => {
      if(auth.currentUser == null) return null;

      const userQuery = query(collection(db, 'Users'), where("identity_id", "==", auth.currentUser.uid))
      const querySnapshot = await getDocs(userQuery);

      if(querySnapshot.size === 0 && currentUser){
        toDataURL(auth.currentUser.photoURL, function (result) {
          setUserImage(result);
        });
        persistUser(auth.currentUser.displayName, auth.currentUser.uid, userImage)
        setUserId(auth.currentUser.uid);
        setUserRole("Regular");
        setUserName(auth.currentUser.displayName)
        
      }else{
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, " => ", doc.data());
          setUserId(doc.data().identity_id);
          setUserRole(doc.data().role_name);
          setUserName(doc.data().first_name)
          setUserImage(doc.data().photo)
          if(!doc.data().photo) setUserImageFlag(true);
          setUserDocId(doc.id);
        }); 

        }
      } 

      useEffect(() => {

        const getUserImage = async () => {
          if(!userImage && auth.currentUser.photoURL){
            console.log('No user image in user collection while present on current user')
            await toDataURL(auth.currentUser.photoURL, function (result) {
              setUserImage(result);
            });
          }
        }

        const updateImage = async () => {
          console.log(userImage)
          const docRef = doc(db, 'Users', userDocId);
          await updateDoc(docRef,{
            photo: userImage
          })
        }

        if(userImageFlag)
          updateImage();

        if(!userImage && currentUser)
          getUserImage();
      }, [userImage])

    async function toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
        
      };
      
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    }

    async function persistUser(name, id, img){
      await addDoc(collection(db, 'Users'), {
        first_name: name,
        identity_id: id,
        role_name: "Regular",
        created_at: Timestamp.fromDate(new Date()),
        photo: img
      });
    }
   
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setCurrentUser(user);
            if(user)
              getUser();
            setLoading(false)
        })
        return unsubscribe;
    }, [])

    const value = {
        currentUser,
        userRole,
        userName,
        userId,
        userImage,
        login,
        logout,
        signup,
        resetPassword
    }

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
}
